import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors } from '../../../styles/Variables'

export const ServicesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;

  .services-banner {

    .content {
      .inner {
        h1 {
          ${mq('max', '430px')} {
            width: 83%;
          }
        }

        p {
          max-width: 60%;

          ${mq('max', '1024px')} {
            max-width: 65%;
          }

          ${mq('max', '960px')} {
            max-width: 69%;
          }

          ${mq('max', '474px')} {
            max-width: 71%;
          }

          ${mq('max', '474px')} {
            max-width: 90%;
          }
        }
      }
    }

    .image-placeholder {

      ${mq('max', '768px')} {
        min-height: 600px;
      }

      img {
        object-position: 50% 45%;
      }
    }
  }

  .web-selectors {
    display: flex;
    flex: 1;
    border-bottom: 1px solid ${gsColors.lightTangerine};
    width: 100%;
    position: sticky;
    background-color: white;
    top: 60px;
    padding: 20px;
    
    ${mq('max', '768px')} {
      padding: 0;
      flex-direction: column;
    }
  }
  
  .market-selector-wrapper {
    max-width: 1600px;
    // margin: 0 auto;

    ${mq('max', '768px')} {
      width: 100%;
    }
  }
`
